module.exports = __webpack_public_path__ + "19700d5a6791a62161513cc05ac2218a.pdf";